var __jsx = React.createElement;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from "react";
import FormField from "../FormField";
import { checkFieldRequiredStatus } from "../../../utils/acrUtils";
import { getFieldError } from "../../../utils/formSectionUtils";
import { useFormSectionContext } from "./FormSectionContext";
import { useLabelMargins } from "./useLabelMargins";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import AwesomeIcon from "../../AwesomeIcon";
import { useTranslation } from "react-i18next";
var FormSubSection = function FormSubSection(_ref) {
  var subSection = _ref.subSection;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFormSectionContex = useFormSectionContext(),
    filteredFields = _useFormSectionContex.filteredFields,
    fieldErrorMap = _useFormSectionContex.fieldErrorMap,
    fieldErrorsList = _useFormSectionContex.fieldErrorsList,
    fieldErrors = _useFormSectionContex.fieldErrors,
    submissionDetail = _useFormSectionContex.submissionDetail,
    formData = _useFormSectionContex.formData,
    handleFieldChange = _useFormSectionContex.handleFieldChange,
    setIsDropdownOpen = _useFormSectionContex.setIsDropdownOpen,
    isSubmissionReadOnly = _useFormSectionContex.isSubmissionReadOnly,
    highlightedFieldName = _useFormSectionContex.highlightedFieldName,
    registryTaggedFields = _useFormSectionContex.registryTaggedFields;

  // Use custom hook for label margin calculations
  var _useLabelMargins = useLabelMargins({
      fields: subSection.fields,
      filteredFields: filteredFields,
      formData: formData
    }),
    labelMargins = _useLabelMargins.labelMargins,
    labelRefsMap = _useLabelMargins.labelRefsMap;

  // Check if sub-section has "at least one required" constraint for patient identifiers
  var atLeastOneConstraint = React.useMemo(function () {
    // Only show badge for patient_identifier "at least one required" constraint
    // Other special checks (risk_factors_required, etc.) don't need the badge
    var patientIdentifierFields = registryTaggedFields === null || registryTaggedFields === void 0 ? void 0 : registryTaggedFields.patient_identifier;
    if (!patientIdentifierFields || patientIdentifierFields.length === 0) {
      return {
        hasConstraint: false,
        fields: []
      };
    }

    // Check if any of the subsection's fields are patient identifier fields
    var matchingFields = subSection.fields.filter(function (fieldName) {
      return patientIdentifierFields.includes(fieldName);
    });
    if (matchingFields.length > 0) {
      // Map field names to labels for display
      var fieldLabels = patientIdentifierFields.map(function (fieldName) {
        var schema = filteredFields.find(function (f) {
          return f.field_name === fieldName;
        });
        return (schema === null || schema === void 0 ? void 0 : schema.label) || fieldName;
      }).filter(Boolean);
      return {
        hasConstraint: true,
        fields: fieldLabels
      };
    }
    return {
      hasConstraint: false,
      fields: []
    };
  }, [registryTaggedFields, filteredFields, subSection.fields]);

  // Check if risk factors are required for this subsection
  var riskFactorRequirement = React.useMemo(function () {
    // Check if any field in this subsection has risk_factors_trigger special check
    var _iterator = _createForOfIteratorHelper(subSection.fields),
      _step;
    try {
      var _loop = function _loop() {
          var _fieldError$condition;
          var fieldName = _step.value;
          var fieldError = fieldErrorsList === null || fieldErrorsList === void 0 ? void 0 : fieldErrorsList.find(function (err) {
            return err.field === fieldName;
          });
          if ((fieldError === null || fieldError === void 0 ? void 0 : fieldError.type) === "special_check" && (fieldError === null || fieldError === void 0 || (_fieldError$condition = fieldError.conditional_metadata) === null || _fieldError$condition === void 0 ? void 0 : _fieldError$condition.field) === "risk_factors_trigger") {
            // Split reasons by semicolon to show as list
            var reasonsValue = fieldError.conditional_metadata.value;
            var reasonsText = reasonsValue ? String(reasonsValue) : t("label.patient_outside_standard_lcsr_criteria");
            var reasons = reasonsText.split("; ").filter(function (r) {
              return r.trim();
            });
            return {
              v: {
                isRequired: true,
                reasons: reasons
              }
            };
          }
        },
        _ret;
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _ret = _loop();
        if (_ret) return _ret.v;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return {
      isRequired: false,
      reasons: []
    };
  }, [subSection.fields, fieldErrorsList]);

  // Get field schema by field name
  var getFieldSchema = function getFieldSchema(fieldName) {
    return filteredFields.find(function (f) {
      return f.field_name === fieldName;
    });
  };

  // Render individual field
  var renderField = function renderField(fieldName) {
    var _submissionDetail$mis, _submissionDetail$fie;
    var field = getFieldSchema(fieldName);
    if (!field) return null;
    var fieldError = fieldErrorMap.get(field.field_name);

    // Check if field is in API's missing_fields array
    var isServerMissing = ((_submissionDetail$mis = submissionDetail.missing_fields) === null || _submissionDetail$mis === void 0 ? void 0 : _submissionDetail$mis.includes(field.field_name)) || false;

    // Use centralized utility to check if field is required
    // This consolidates: static required, conditional required, special check required, and server missing
    var isRequired = checkFieldRequiredStatus(field, fieldErrorsList, isServerMissing);

    // Regular field rendering - all fields displayed independently
    var validationError = fieldError ? fieldError.error : getFieldError(field.field_name, fieldErrors);

    // Get calculated margin for this field
    var labelMarginBottom = labelMargins.get(field.field_name) || 0;
    return /*#__PURE__*/React.createElement(FormField, {
      field: field,
      status: isRequired ? "missing" : "",
      isFieldRequired: isRequired,
      key: field.field_name,
      formData: formData,
      handleFieldChange: handleFieldChange,
      onDropdownStateChange: setIsDropdownOpen,
      validationError: validationError,
      conditionalError: fieldError,
      isSubmissionReadOnly: isSubmissionReadOnly,
      fieldDataSource: (_submissionDetail$fie = submissionDetail.field_data_source) === null || _submissionDetail$fie === void 0 ? void 0 : _submissionDetail$fie[field.field_name],
      highlightedFieldName: highlightedFieldName,
      isServerMissing: isServerMissing,
      labelRef: function labelRef(el) {
        return labelRefsMap.current.set(field.field_name, el);
      },
      labelMarginBottom: labelMarginBottom
    });
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full mt-4 py-2 text-left text-sm flex gap-2 items-center font-semibold border-b border-[#BBBFC2] dark:border-[#646B72] uppercase tracking-wider"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#646B72] dark:text-[#9EA3A8]"
  }, subSection.label))), !isSubmissionReadOnly && atLeastOneConstraint.hasConstraint && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 p-4 rounded-lg border border-[#FBDF9B] bg-yellow-100 dark:border-[#805500] dark:bg-yellow-800/20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-3 items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faExclamationTriangle,
    size: "sm",
    className: "text-yellow-700 dark:text-yellow-400/80"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 text-left text-yellow-700 dark:text-yellow-400/80"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-md"
  }, t("label.atleast_one_field_required"), " \u2014", " ", atLeastOneConstraint.fields.join(", "))))), riskFactorRequirement.isRequired && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 p-4 rounded-lg border border-[#FBDF9B] bg-yellow-100 dark:border-[#805500] dark:bg-yellow-800/20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-3 items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faExclamationTriangle,
    size: "sm",
    className: "text-yellow-700 dark:text-yellow-400/80"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 text-left text-yellow-700 dark:text-yellow-400/80"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-md"
  }, t("label.patient_outside_standard_lcsr_criteria"), ":", " ", riskFactorRequirement.reasons.join(", "))))), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 gap-4 items-start"
  }, subSection.fields.map(function (fieldName) {
    return renderField(fieldName);
  })));
};
export default FormSubSection;